import { pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const FileInput = styled.input `
  width: ${pxToRem(1)};
  height: ${pxToRem(1)};
  appearance: none;
  opacity: 0;
`;
